// ============================================================================
// broiler.dailys.detail — the broiler daily record page, off App's boot array
// ============================================================================
// The record read was already page-local; `broiler.daily.detail` keeps its
// exact projection, its eq(id) shape and its deleted_at filter, so a
// soft-deleted report still resolves to not-found rather than to a row. What
// actually changed here is the second obligation: the group dropdown's batch
// array used to arrive as a BroilerEntry prop carrying App's former-eager
// ppp-v4 boot result.
//
// This surface migrated in the SAME change as its index sibling, not because
// its own read demanded it, but because broiler.dailys.batchDirectory is read
// in BroilerDailysRouter above the index/record branch and a catalog resource
// may only name surfaces the manifest declares migrated. Migrating the hub
// alone would have left this page consuming a permanent resource it did not
// own.
//
// `sb` and `authState` remain props from the router. Neither is a data read:
// one is the transport, the other the identity the shared collaboration
// section and the ownership predicates already take.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'broiler.dailys.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'broiler.daily.detail', owner: 'permanent'}),
    Object.freeze({id: 'broiler.dailys.batchDirectory', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
